import { useEffect, useState } from 'react'

export const useCurrentTspOnly = () => {
  const [isCurrentTspOnly, setIsCurrentTspOnly] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('singlePage=true')) {
      setIsCurrentTspOnly(true)
      sessionStorage.setItem('singlePage', 'true')
    } else {
      const IsCurrentTspOnlyFromStorage = sessionStorage.getItem('singlePage')

      if (IsCurrentTspOnlyFromStorage) {
        setIsCurrentTspOnly(IsCurrentTspOnlyFromStorage === 'true')
      }
    }
  }, [])

  return { isCurrentTspOnly, setIsCurrentTspOnly }
}
